import React, { Component, Fragment } from 'react';

import { ButtonIcon } from 'components/button';
import { Grid } from 'components/grid';
import { Loader } from 'components/loader';
import { Modal } from 'components/modal';
import Pagination from 'components/pagination';
import { VALUES_PER_PAGE } from 'components/pagination/constants';
import { I18n, translate } from 'components/translate';
import DateHelper from 'helpers/Date';
import { IMPORT_TYPES } from 'modules/userManager/constants';
import { ImportService } from 'modules/userManager/imports';
import PropTypes from 'prop-types';

import ImportHistoryDetail from './ImportHistoryDetail';

import './ImportHistory.scss';

@translate()
export default class ImportHistory extends Component {
  static propTypes = {
    t: PropTypes.func,
    tabIndex: PropTypes.number
  };

  state = {
    content: [],
    totalElements: 0,
    page: 0,
    perPage: VALUES_PER_PAGE.TEN,
    sort: 'desc',
    loaded: true,
    detailModal: false,
    detailId: null,
    firstLoad: false
  };

  get params() {
    const { sort, page, perPage: size } = this.state;

    return {
      sort: `startDate,${sort}`,
      page,
      size
    };
  }

  componentDidMount() {
    this.fetchHistory();
  }

  componentDidUpdate(prevProps) {
    if (
      // eslint-disable-next-line @typescript-eslint/no-magic-numbers
      this.props.tabIndex === 3 &&
      this.props.tabIndex !== prevProps.tabIndex
    ) {
      this.fetchHistory();
    }
  }

  fetchHistory = async () => {
    this.toggleLoader();

    const data = await ImportService.getImportHistory(this.params);

    if (data) {
      this.setState({ ...data });
    }

    this.toggleLoader();
  };

  showHistoryDetail = (detailId) => {
    this.setState({ detailModal: true, detailId });
  };

  toggleLoader = () => {
    this.setState((prevState) => ({
      loaded: !prevState.loaded,
      firstLoad: true
    }));
  };

  changePage = (page) => {
    this.setState({ page }, () => {
      this.fetchHistory();
    });
  };

  changePerPage = (perPage) => {
    this.setState({ perPage, page: 0 }, () => {
      this.fetchHistory();
    });
  };

  onCloseModal = () => {
    this.setState({ detailModal: false, detailId: null });
  };

  changeSort = () => {
    this.setState(
      (prevState) => {
        return prevState.sort === 'desc' ? { sort: 'asc' } : { sort: 'desc' };
      },
      () => {
        this.fetchHistory();
      }
    );
  };

  importLabel = (importType) => {
    const { t } = this.props;

    return IMPORT_TYPES[importType] ? t(IMPORT_TYPES[importType]) : '';
  };

  get renderInfoModal() {
    const { detailId } = this.state;

    return (
      <Modal fullSize onClose={this.onCloseModal}>
        <Modal.Header>
          {(context) => (
            <Fragment>
              <ButtonIcon
                className="close"
                transparent
                type="secondary"
                icon="close"
                onClick={context.actions.closeModal}
              />
              <h2>
                <I18n label="users_import.history.detail.title" />
              </h2>
            </Fragment>
          )}
        </Modal.Header>
        <Modal.Body>
          <ImportHistoryDetail
            id={detailId}
            description={this.getDetailDescription}
          />
        </Modal.Body>
      </Modal>
    );
  }

  get getDetailDescription() {
    const { detailId, content } = this.state;

    const data = content.find((item) => item.id === detailId);

    return `${this.importLabel(data.importType)} - ${DateHelper.formatDate(
      data.startDate
    )}`;
  }

  renderEmptyList() {
    return (
      <Grid block>
        <div className="empty__history">
          <div className="empty__list__icon">
            <i className="icon icon-empty" />
          </div>
          <div className="empty__history__description">
            <I18n label="users_import.history.empty" />
          </div>
        </div>
      </Grid>
    );
  }

  render() {
    const { firstLoad, content } = this.state;

    if (firstLoad && !content.length) {
      return this.renderEmptyList();
    }

    return this.renderHistoryList();
  }

  renderHistoryList() {
    const { content, totalElements, page, perPage, loaded, detailModal, sort } =
      this.state;

    return (
      <Grid block>
        <h2>
          <I18n label="users_import.history.title" />
        </h2>
        <label className="label__subtitle mb__lg">
          <I18n label="users_import.history.description" />
        </label>
        <table className="table">
          <thead>
            <tr>
              <th>
                <span
                  onClick={this.changeSort}
                  className={`arrow_${sort === '' ? 'sort' : sort}`}
                >
                  <I18n label="general.date" />
                </span>
              </th>
              <th>
                <I18n label="general.type" />
              </th>
              <th>
                <I18n label="general.quantity" />
              </th>
              <th>
                <I18n label="general.status" />
              </th>
            </tr>
          </thead>
          <tbody>
            {content.map((item) => (
              <tr key={item.id}>
                <td data-header={`${this.props.t('general.date')}:`}>
                  {DateHelper.formatDate(item.startDate)}
                </td>
                <td data-header={`${this.props.t('general.type')}:`}>
                  {this.importLabel(item.importType)}
                </td>
                <td data-header={`${this.props.t('general.quantity')}:`}>
                  {item.importedUsers}
                </td>
                <td data-header={`${this.props.t('general.status')}:`}>
                  <span
                    className="history__info"
                    onClick={() => this.showHistoryDetail(item.id)}
                  >
                    {'+'} <I18n label="general.details" />
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        <Pagination
          className="mt__md"
          totalRegisters={totalElements}
          currentPage={page}
          changePage={this.changePage}
          changePerPage={this.changePerPage}
          perPage={perPage}
        />
        {!loaded && <Loader key="loader" mask />}
        {detailModal && this.renderInfoModal}
      </Grid>
    );
  }
}
